import { render, staticRenderFns } from "./EditSGConfig.vue?vue&type=template&id=27699200&scoped=true"
import script from "./EditSGConfig.vue?vue&type=script&lang=js"
export * from "./EditSGConfig.vue?vue&type=script&lang=js"
import style0 from "./EditSGConfig.vue?vue&type=style&index=0&id=27699200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27699200",
  null
  
)

export default component.exports